import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Limpia el error anterior
    setIsLoading(true);

    try {
      const result = await login(email, password);
      
      if (result.success) {
        toast.success('¡Bienvenido!');
        navigate('/dashboard');
      } else {
        const errorMsg = result.error || 'Credenciales inválidas';
        setError(errorMsg);
        toast.error(errorMsg);
      }
    } catch (error) {
      const errorMsg = 'Error al iniciar sesión';
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e1e1e 0%, #171717 100%)', position: 'relative' }}>
      <video
        autoPlay
        loop
        muted
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2, zIndex: 1 }}
      >
        <source src="/loginbg.mp4" type="video/mp4" />
      </video>
      
      <div style={{ position: 'relative', zIndex: 10, width: '100%', maxWidth: '480px', padding: '0 24px' }}>
        <div style={{ background: '#232323', borderRadius: '16px', boxShadow: '0 30px 60px rgba(0,0,0,0.5)', padding: '32px', border: '1px solid rgba(255,255,255,0.1)' }}>
          {/* Logo */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
            <img
              src="/racingmotors.png"
              alt="Racing Motors"
              style={{ height: '64px' }}
            />
          </div>

          {/* Title */}
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', marginBottom: '24px', color: '#fff' }}>
            Racing Motors
          </h2>

          {/* Form */}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label htmlFor="email" style={{ display: 'block', fontSize: '14px', fontWeight: 600, marginBottom: '8px', color: '#cfcfcf' }}>
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(''); // Limpia el error al escribir
                }}
                required
                style={{ 
                  width: '100%', 
                  padding: '10px 12px', 
                  borderRadius: '8px', 
                  border: error ? '1px solid #ef476f' : '1px solid rgba(255,255,255,0.15)', 
                  background: '#2a2a2a', 
                  color: '#fff',
                  outline: 'none'
                }}
                placeholder="tu@racingmotorsmexico.com"
              />
            </div>

            <div>
              <label htmlFor="password" style={{ display: 'block', fontSize: '14px', fontWeight: 600, marginBottom: '8px', color: '#cfcfcf' }}>
                Contraseña
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(''); // Limpia el error al escribir
                }}
                required
                style={{ 
                  width: '100%', 
                  padding: '10px 12px', 
                  borderRadius: '8px', 
                  border: error ? '1px solid #ef476f' : '1px solid rgba(255,255,255,0.15)', 
                  background: '#2a2a2a', 
                  color: '#fff',
                  outline: 'none'
                }}
                placeholder="••••••••"
              />
              {error && (
                <div style={{ marginTop: '8px', fontSize: '14px', color: '#ef476f' }}>
                  {error}
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn btn--primary"
              style={{ width: '100%', height: '44px', fontSize: '16px' }}
            >
              {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>

          <p style={{ marginTop: '16px', textAlign: 'center', fontSize: '12px', opacity: 0.6, color: '#fff' }}>
            Sistema de Gestión Administrativa
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;

